import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { DashboardsListResponse } from "@src/types/dashboards";

export interface GetDashboardsV2Result {
  success: boolean;
  data?: DashboardsListResponse;
  error?: string;
}

export const getDashboardsV2UseCase =
  async (): Promise<GetDashboardsV2Result> => {
    try {
      const namespace =
        store.getState().yourSlice.authContext.customerNamespace;
      const response = await apiUseCases.getDashboardsV2(namespace);

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      return {
        success: false,
        error: parseAxiosApiError(error, "Failed to fetch dashboards").message,
      };
    }
  };
